import api, { apiExtract } from '../config/api';
import type { BlockConfirmData, CurrenciesData, MethodsInfo, PaymentInfo, WalletPayData } from './model';

export interface GetInvoiceInfoParams {
  uuid: string;
  search?: string;
}

export interface GetInvoiceMethodParams {
  currency: string;
  network: string;
  amount?: string;
  merchant?: string;
}

export interface GetInvoiceMethodsParams {
  search: string;
  uuid: string;
  currency?: string;
}

interface PaymentConfirmsParams {
  uuid: string;
}

interface LoadAverageParams {
  average: string;
  uuid: string;
}

export interface LeaveContactParams {
  email: string;
  lang: string;
  uuid: string;
}

export interface PayViaWalletPayParams {
  uuid: string;
  currency?: string;
  network?: string;
  payload?: string;
}

export interface IPayViaMercuryoPayload {
  uuid: string;
  currency?: string;
  network?: string;
  payload?: string;
}

export interface IPayViaMercuryoResponse {
  params: {
    address: string;
    amount: string;
    currency: string;
    fixAmount: string;
    fixCurrency: string;
    fixNetwork: string[];
    network: string;
    signature: string;
    type: string;
    widgetId: string;
  };
}

export const InvoiceService = {
  async getBinanceLink(data: { uuid: string }) {
    return apiExtract.post('v1/payment/binance-pay', data);
  },

  async getInvoiceCurrencies(data: GetInvoiceInfoParams) {
    return apiExtract.post<CurrenciesData>('v1/payment/currencies', data);
  },

  async getInvoiceInfo(data: GetInvoiceInfoParams) {
    return apiExtract.post<PaymentInfo>('v1/payment/info', data);
  },

  async getInvoiceMethod(data: GetInvoiceMethodParams) {
    return api.post('v1/payment/method', data);
  },

  async getInvoiceMethods(data: GetInvoiceMethodsParams) {
    return apiExtract.post<MethodsInfo>('v1/payment/methods', data);
  },

  async getPayViaFiat(data: any) {
    return apiExtract.post('v1/payment/fiat', data);
  },

  async getPayViaFiatCancel(uuid: string) {
    return apiExtract.post<{ deal_id?: string }>('v1/payment/fiat/cancel', {
      uuid,
    });
  },

  async leaveContact(data: LeaveContactParams) {
    return apiExtract.post('v1/payment/leave-contact', {
      email: data.email,
      uuid: data.uuid,
    });
  },

  async loadAverage(data: LoadAverageParams) {
    return apiExtract.post('v1/fingerprint/average', data);
  },

  async payViaMercuryo(data: IPayViaMercuryoPayload) {
    return apiExtract.post<IPayViaMercuryoResponse>('v1/payment/mercuryo', data);
  },

  async payViaWalletPay(data: PayViaWalletPayParams) {
    return apiExtract.post<WalletPayData>('v1/payment/wallet-pay', data);
  },

  async paymentConfirms(data: PaymentConfirmsParams) {
    return apiExtract.post<BlockConfirmData>('v1/payment/confirms', data);
  },

  async setFingerprint(data: { request_id: string; uuid: string }) {
    return apiExtract.post('v1/fingerprint/event', data);
  },

  async setInvoiceRefuse(data: { uuid: string }) {
    return apiExtract.post('v1/payment/refuse-surcharge', data);
  },

  async walletConnectSuccessPayment(uuid: string) {
    return apiExtract.post('v1/fingerprint/walletconnect', { uuid });
  },
};
